import { useEffect, useState } from 'react';

import { useHttpClient } from 'src/lib/http-client/use-http-client';

type ResponseType = {
    label: string;
    value: string;
};

export const useGetAllArticleType = (
    subCategoryId: string,
    language: string
): ResponseType[] => {
    const [state, setState] = useState<ResponseType[]>([]);
    const httpClient = useHttpClient();

    const makeRequestToGetAllArticleType = (): Promise<ResponseType[]> => {
        return httpClient.get<ResponseType[]>(
            `item-subcategories/${subCategoryId}/item-types`
        );
    };

    const updateArticleType = async (): Promise<void> => {
        const data: ResponseType[] = await makeRequestToGetAllArticleType();
        setState(data);
    };

    useEffect(() => {
        if (subCategoryId) {
            updateArticleType();
        } else {
            setState([]);
        }
    }, [subCategoryId, language]);

    return state;
};
